export default {
    shadow: process.env.REACT_APP_URI_SHADOW,
};
